import { Link } from "react-router-dom";
import type { Topic } from "@/types/content";
import { formatDateC, getCategoryName } from "@/lib/content";

const toc = [
  { id: "overview", label: "事件概述" },
  { id: "timeline", label: "时间线还原" },
  { id: "dialogue", label: "对话实录" },
  { id: "responses", label: "各方回应" },
  { id: "notes", label: "观察笔记" },
];

export default function ArticleAside({ topic }: { topic: Topic }) {
  const info = [
    { label: "内容方向", value: getCategoryName(topic.category) },
    { label: "整理日期", value: formatDateC(topic.date) },
    { label: "阅读时长", value: topic.readTime },
    { label: "阅读量", value: topic.views },
  ];

  return (
    <div className="sticky top-24 flex flex-col gap-6">
      <nav
        aria-label="本页目录"
        className="rounded-lg border border-background-200 bg-background-100 p-5"
      >
        <h2 className="font-heading text-sm font-semibold text-foreground-950">本页目录</h2>
        <ul className="mt-3 space-y-1.5">
          {toc.map((item, index) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm text-foreground-600 transition-colors hover:bg-background-200 hover:text-primary-600"
              >
                <span className="font-heading text-xs text-foreground-400">
                  {String(index + 1).padStart(2, "0")}
                </span>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="font-heading text-sm font-semibold text-foreground-950">档案信息</h2>
        <dl className="mt-3 space-y-2.5 text-sm">
          {info.map((row) => (
            <div key={row.label} className="flex items-center justify-between gap-3">
              <dt className="text-foreground-500">{row.label}</dt>
              <dd className="text-foreground-900">{row.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
        <div className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
          <i className="ri-file-copy-2-line text-lg" />
        </div>
        <h2 className="mt-3 font-heading text-sm font-semibold text-foreground-950">引用与转载</h2>
        <p className="mt-2 text-xs leading-relaxed text-foreground-600">
          引用本页整理内容时，请注明来源「黑料吃话」并附原文链接。原始素材请以其发布出处为准。
        </p>
        <Link
          to="/about#contact"
          className="mt-3 inline-flex items-center gap-1 text-xs text-primary-600 transition-colors hover:text-primary-700"
        >
          申请授权说明
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </div>
  );
}